enum Stat {
    Responsiveness,
    ProjectCount,
    RepeatClients,
}

export default Stat;
